<script>
import AnalyticsFile from "@/components/ui/waermeplanung/AnalyticsFile.vue";
import {mapActions, mapGetters} from "vuex";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";

export default {
  name: "WaermeAnalytics",
  components: {Breadcrumbs, AnalyticsFile },
  data: () => ({
    header: require("../assets/header-analyse-waermeplanung.png"),
    selectedCategory: 'Alle Kategorien',
    selectedCommune: 'Alle Kommunen',
    selectedSortOption: 'Neueste',
    sortOptions: ['Neueste', 'Älteste'],
    showFilter: false,
  }),
  computed: {
    ...mapGetters('waerme', ['getFiles']),
    headerStyle() {
      return {
        'font-size': this.$vuetify.breakpoint.smAndUp ? '40px' : '2rem'
      }
    },
    categories() {
      return ["Alle Kategorien", ...new Set(this.getFiles.map(f => f.kategorie))];
    },
    communes() {
      return ["Alle Kommunen", ...new Set(this.getFiles.map(f => f.commune))];
    },
    files() {
      return this.getFiles
          .filter(f => this.selectedCategory === 'Alle Kategorien' || this.selectedCategory === f.kategorie)
          .filter(f => this.selectedCommune === 'Alle Kommunen' || this.selectedCommune === f.commune)
          .toSorted((a, b) => {
            if(this.selectedSortOption === 'Neueste') return new Date(b.datum) - new Date(a.datum);
            return new Date(a.datum) - new Date(b.datum);
          });
    }
  },
  methods: {
    ...mapActions('waerme', ['loadFiles'])
  },
  mounted() {
    this.loadFiles();
  }
}
</script>

<template>
  <div class="max-w-container">
    <v-img :src="header" class="mb-5 testate-header" gradient="to top, #000000CE, #54545422">
      <v-row no-gutters class="fill-height pa-2 px-5 d-flex align-end">
        <v-col cols="12">
          <breadcrumbs />
          <div class="custom-header-text mb-2 white--text new-font-bold" :style="headerStyle">Analyse zur Wärmeplanung</div>
        </v-col>
      </v-row>
    </v-img>
    <div class="pa-5">
      <div class="d-flex flex-row flex-wrap" v-if="$vuetify.breakpoint.width >= 900">
        <div style="width: 200px" class="mr-2"><v-select :items="categories" v-model="selectedCategory" dense
                                                         background-color="#f6e4ed"
                                                         outlined hide-details single-line /></div>
        <div style="width: 200px" class="mr-2"><v-select :items="communes" v-model="selectedCommune" dense
                                                         background-color="#f6e4ed"
                                                         outlined hide-details single-line /></div>
        <v-spacer />
        <div style="width: 200px"><v-select
            dense
            background-color="#f6e4ed"
            outlined
            :items="sortOptions" v-model="selectedSortOption"  hide-details single-line /></div>
      </div>
      <v-row v-else>
        <template v-if="showFilter">
          <v-col cols="12" sm="6"><v-select :items="categories" v-model="selectedCategory" dense
                                            background-color="#f6e4ed"
                                            outlined hide-details single-line /></v-col>
          <v-col cols="12" sm="6"><v-select :items="communes" v-model="selectedCommune" dense
                                            background-color="#f6e4ed"
                                            outlined hide-details single-line /></v-col>
          <v-col cols="12" sm="6"><v-select :items="sortOptions" v-model="selectedSortOption" dense
                                            background-color="#f6e4ed"
                                            outlined hide-details single-line /></v-col>
        </template>
        <v-col cols="12">
          <v-btn
              @click="showFilter = !showFilter"
              block
              outlined
              color="primary"
          >
            <v-icon color="primary"
            >mdi-chevron-{{ showFilter ? "up" : "down" }}
            </v-icon>
            Filter {{ showFilter ? "ausblenden" : "anzeigen" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-sheet color="primary" class="pa-3 mt-5" style="border-top-left-radius: 5px; border-top-right-radius: 5px;">
        <v-row class="header-row">
          <v-col cols="3" class="py-0 px-2 d-flex align-center">
            Kommune
          </v-col>
          <v-col cols="3" class="py-0 px-2 d-flex align-center">
            Kategorie
          </v-col>
          <v-col cols="2" class="py-0 px-2 d-flex align-center">
            Datum
          </v-col>
          <v-col cols="2" class="py-0 px-2 d-flex align-center">
            Download
          </v-col>
          <v-col cols="2" class="py-0 px-2 d-flex align-center">
            Status
          </v-col>
        </v-row>
      </v-sheet>
      <analytics-file v-for="file of files" :key="file.osid" :file="file"></analytics-file>
    </div>
  </div>
</template>

<style scoped>
.testate-header {
  aspect-ratio: 960/288;
}

.header-row div{
  color: white;
  font-size: 16px;
  height: 32px;
}
</style>
